import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DwAction, DwActionHandler, DwActionResult, DwActionType } from '@devwareapps/devware-cap';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const MY_ORDERS_ACTION = 'fitness-my-orders';
@DwAction({keyName: MY_ORDERS_ACTION, display: 'My orders', actionType: DwActionType.menuAction,
    isGlobal: true, allowOnce: false, configData: {requireValidation: false, redirectAfter: false, actionMessage: ''}})
@Injectable()
export class MyOrdersAction implements DwActionHandler {
    constructor(private router: Router) {}
    handleAction(): Observable<DwActionResult> {
        return from(this.router.navigate(['/store/orders'])).pipe(
            map(success => Object.assign(new DwActionResult(), {success})));
    }
}
